import React from 'react';
import { IconType } from 'react-icons';
import { TbPlus } from 'react-icons/tb';
import { LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import IconLink from '../links/IconLink';
import UnderlinedLink from '../links/UnderlinedLink';

export default function OverviewCard({
  icon: Icon,
  title,
  className,
  mainFigure,
  totalCount,
  createLinkProps,
  seeMoreText,
  seeMoreLinkProps,
  children,
}: {
  icon: IconType;
  title: string;
  className?: string;
  mainFigure?: number;
  totalCount?: number;
  createLinkProps?: Omit<LinkProps, 'children'>;
  seeMoreLinkProps?: Omit<LinkProps, 'children'>;
  seeMoreText?: string;
  children?: React.ReactNode;
}): JSX.Element {
  return (
    <div
      className={twMerge(
        'relative flex flex-col gap-3 rounded-[12px] bg-secondary-200/70 p-4',
        className,
      )}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1">
          <h3 className="text-sm font-medium text-gray-500">
            {title}
            {totalCount !== undefined && (
              <span className="text-primary-300"> ({totalCount})</span>
            )}
          </h3>
          {mainFigure !== undefined && (
            <p className="mt-1 text-4xl font-semibold text-primary-900">{mainFigure}</p>
          )}
        </div>
        <div className="flex items-start gap-1">
          {createLinkProps && <IconLink icon={TbPlus} {...createLinkProps} />}
          <div className="flex h-9 w-9 items-center justify-center rounded-[8px] bg-primary-100 text-primary-900">
            <Icon className="flex-shrink-0" size={18} />
          </div>
        </div>
      </div>
      {children && <span className="flex-1 text-sm text-gray-500">{children}</span>}
      {seeMoreLinkProps && (
        <div className="z-10 flex w-full justify-end align-bottom">
          <UnderlinedLink {...seeMoreLinkProps}>{seeMoreText}</UnderlinedLink>
        </div>
      )}
    </div>
  );
}
